import { Component, Output, EventEmitter } from '@angular/core';
import { ClientSearchBy, SEARCH_BY, PLACEHOLDERS, CLIENT_SEARCH_OPTIONS, CLIENT_PLACEHOLDERS, CLIENT_SEARCH_BY } from '@common/interfaces';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-client-search',
  templateUrl: './client-search.component.html',
  styleUrls: ['./client-search.component.scss']
})
export class ClientSearchComponent {
   @Output() searchData = new EventEmitter();

  searchStr: string = '';
  activeCol: { title: string; value: string }[] = [];
  searchOptions =  [
  { title: 'Client Name', value: 'CLIENT_NAME' },
  { title: 'Added By', value: 'CREATED_BY' }
];;

  private searchSubject = new Subject<string>();
  private searchSubscription!: Subscription;

  ngOnInit(): void {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.emitSearchData();
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }

  changeIndex(event: string) {
    this.activeCol = this.searchOptions.filter(
      (option) => option.value === event
    );
  }

  removeClick() {
    this.searchStr = '';
    this.emitSearchData();
  }

  search() {
    this.emitSearchData();
  }

  onInputChange() {
    this.searchSubject.next(this.searchStr);
  }

  private emitSearchData() {
    this.searchData.emit({
      searchBy: this.activeCol[0]?.value || CLIENT_SEARCH_BY.CLIENT_NAME,
      searchText: this.searchStr
    });
  }

  get searchPlaceholder(): string {
    const selectedValue = this.activeCol[0]?.value as ClientSearchBy || CLIENT_SEARCH_BY.CLIENT_NAME;
    return CLIENT_PLACEHOLDERS[selectedValue] || CLIENT_PLACEHOLDERS[CLIENT_SEARCH_BY.CLIENT_NAME];
  }
}
